/// <reference types="vite/client" />

import { QueryClientProvider } from "@tanstack/solid-query";
import { HeadContent, Outlet, Scripts, createRootRoute } from "@tanstack/solid-router";

import { queryClient } from "@/scripts/queries";

const Route = createRootRoute({
	head: () => ({
		links: [
			{ rel: "apple-touch-icon", sizes: "180x180", href: "/apple-touch-icon.png" },
			{ rel: "icon", type: "image/svg+xml", href: "/icon.svg" },
			{ rel: "manifest", href: "/manifest.webmanifest", color: "#ffffff" },
			{ rel: "icon", href: "/favicon.ico", sizes: "32x32" },
		],
	}),
	component: () => (
		<QueryClientProvider client={queryClient}>
			<HeadContent />

			<Outlet />

			<Scripts />
		</QueryClientProvider>
	),
});

export { Route };
